<template>
  <Article
    :page="page"
  />
</template>

<script>
import Article from '../../../components/Blog/Article';

export default {
  components: { Article },
  async asyncData({
    $axios, route, $config, error,
  }) {
    const page = await $axios.$get(`/blog/posts/${route.params.blogArticle}`).catch(() => false);

    if (!page || route.params.blogCategory !== page.parentCategorySlug || route.params.blogSubItem !== page.categorySlug) {
      return error({ title: 'Not found', statusCode: 404, message: 'Article not found' });
    }

    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.slug = route.params.blogArticle;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    return {
      page,
    };
  },
  head() {
    return {
      script: [
        {
          src: 'https://ccf26a.365datascience.com/app/js/api.min.js', async: true, type: 'text/javascript', 'data-account': '86498', 'data-user': '76915', 'data-api': 'acf268',
        },
      ],
    };
  },
};
</script>
